/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Table_ValueInputs */



/**
* | output |
* | --- |
* | "Metadata Value" |
*
* @param {Event_Group_Metadata_Table_ValueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_table_value = /** @type {((inputs?: Event_Group_Metadata_Table_ValueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Table_ValueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Valeur des métadonnées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadatenwert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Valore dei metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Значение метаданных")
	if (locale === "es") return /** @type {LocalizedString} */ ("Valor de metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("元数据值")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータ値")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा मान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Valor dos metadados")
	return /** @type {LocalizedString} */ ("Metadata Value")
});